
import api, { apiInternal } from '../api';


export async function getConnectors() {
  const { data } = await api.post(`${apiInternal}/global/connectors`, {});
 
  return data;
}

export async function refreshToken(){
  return await api.refreshtoken()
}